var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("layout-1", {
        staticStyle: {
          width: "63%",
          height: "calc(100vh - 90px)",
          float: "left"
        },
        attrs: {
          table_name: "Job Orders",
          id: _vm.pageid2,
          searchbar: true,
          termchange: true,
          button_name: "Add",
          button_perm: "72"
        },
        on: { select: _vm.selectJobOrder }
      }),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("layout-3", {
            staticStyle: { width: "35%", "max-height": "30vh", float: "right" },
            attrs: { id: _vm.pageid4, term: _vm.term, width: 3, height: 2 }
          }),
          _vm._v(" "),
          _c("layout-1", {
            key: _vm.updateKey,
            staticStyle: {
              width: "36%",
              height: "calc(100vh - 90px - 30vh)",
              float: "right"
            },
            attrs: {
              table_name: "PO Number Job Orders",
              id: _vm.pageid3,
              term: _vm.term,
              termchange: true,
              button_name: "Remove",
              button_perm: "72"
            },
            on: { select: _vm.removeJobOrder }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "nav-bar" }, [
        _c("div", [
          _c(
            "button",
            {
              on: {
                click: function($event) {
                  return _vm.back()
                }
              }
            },
            [_vm._v("Done")]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00449606", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00449606","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/Edit_PO_Number_Job_Orders.vue
// module id = 689
// module chunks = 0